<template>
  <v-chip small label>
    <v-icon class="mr-1" :color="type" v-html="type" />
    <slot />
  </v-chip>
</template>

<script>
  export default {
    props: {
      type: String,
    },
  }
</script>